import { render, staticRenderFns } from "./itemEditDialog.vue?vue&type=template&id=4a8d0567&scoped=true"
import script from "./itemEditDialog.vue?vue&type=script&lang=js"
export * from "./itemEditDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a8d0567",
  null
  
)

export default component.exports